const licenseMap = {
    free: {
        level: 0,
        planId: "freeplan",
        type: "Free",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 100,
        locations: 1,
        uploadlimit: 2048,
        language: false,
        premium_journeys: false,
        premium_games: false,
        smtp: false,
        gtm_pixel: false
    },
    essentialsmonthly: {
        level: 1,
        planId: "plan_LXNIlgjvOQnv49",
        type: "Essentials",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 100,
        locations: 1,
        uploadlimit: 2048,
        language: false,
        premium_journeys: false,
        premium_games: false,
        smtp: false,
        gtm_pixel: false
    },
    essentialsannual: {
        level: 1,
        planId: "plan_LZdfWMebVWLRPJ",
        type: "Essentials",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 100,
        locations: 1,
        uploadlimit: 2048,
        language: false,
        premium_journeys: false,
        premium_games: false,
        smtp: false,
        gtm_pixel: false
    },
    promonthly: {
        level: 2,
        planId: "plan_LWvbNSYbWXVsGR",
        type: "Pro",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 500,
        locations: 5,
        uploadlimit: 10240,
        language: true,
        premium_journeys: true,
        premium_games: true,
        smtp: true,
        gtm_pixel: true
    },
    proannual: {
        level: 2,
        planId: "plan_LZeJZkIdD1Ezh7",
        type: "Pro",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 500,
        locations: 5,
        uploadlimit: 10240,
        language: true,
        premium_journeys: true,
        premium_games: true,
        smtp: true,
        gtm_pixel: true
    },
    enterprise: {
        level: 3,
        planId: "enterpriseplan",
        type: "Enterprise",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 99999999,
        locations: 99999999,
        uploadlimit: 51200,
        language: true,
        premium_journeys: true,
        premium_games: true,
        smtp: true,
        gtm_pixel: true
    },
    appsumo: {
        level: 2,
        planId: "app_sumo",
        type: "Appsumo",
        campaigns: 5,
        leads: false,
        customLogo: false,
        logicJumps: false,
        poweredBy: true,
        privateCampaigns: false,
        geoAnalytics: false,
        enrollUser: 100,
        locations: 1,
        uploadlimit: 2048,
        language: false,
        premium_journeys: false,
        premium_games: false,
        smtp: false,
        gtm_pixel: false
    },
};
const licenseLadder = {
    appSumo: {
        l1: {
            license_name: "Essentials",
            license_type: "Inductor",
            subscription_plan: "AppSumoL1",
            end_date: new Date(7258118399000),
            maxUsers: 100,
            maxSpace: 2048,
            maxDecks: 1,
            code: 1,
            features: [
                "100 Active Users",
                "Max 12 Content Pieces",
            ],
        },
        l2: {
            license_name: "Essentials",
            license_type: "Inductor",
            subscription_plan: "AppSumoL2",
            end_date: new Date(7258118399000),
            maxUsers: 300,
            maxSpace: 2048,
            maxDecks: 2,
            code: 2,
            features: [
                "300 Active Users",
                "Max 24 Content Pieces"
            ],
        },
        l3: {
            license_name: "Pro",
            license_type: "Inductor",
            subscription_plan: "AppSumoL3",
            end_date: new Date(7258118399000),
            maxUsers: 500,
            maxSpace: 5120,
            maxDecks: 5,
            code: 3,
            features: [
                "500 Active Users",
                "Max 60 Content Pieces",
                "Custom Domain",
                "Premium Themes",
                "Premium Games"
            ],
        },
        l4: {
            license_name: "Pro",
            license_type: "Inductor",
            subscription_plan: "AppSumoL4",
            end_date: new Date(7258118399000),
            maxUsers: 700,
            maxSpace: 5120,
            maxDecks: 8,
            code: 4,
            features: [
                "700 Active Users",
                "Max 96 Content Pieces",
                "Custom Domain",
                "Premium Themes",
                "Premium Games"
            ],
        },
        l5: {
            license_name: "Pro",
            license_type: "Inductor",
            subscription_plan: "AppSumoL5",
            end_date: new Date(7258118399000),
            maxUsers: 1000,
            maxSpace: 5120,
            maxDecks: 10,
            code: 5,
            features: [
                "1000 Active Users",
                "Max 120 Content Pieces",
                "Custom Domain",
                "Premium Themes",
                "Premium Games"
            ],
        },
        free: {
            license_name: "Free",
            maxUsers: 100,
            maxDecks: 1,
            features: [
                "100 Active Users",
                "All Product Features",
                "Max 12 Content Pieces",
                "Upload Size Limit: 2MB per piece"
            ]
        },
        essentials: {
            license_name: "Essentials",
            maxUsers: 100,
            maxDecks: 1,
            features: [
                "100 Active Users",
                "All Product Features",
                "Max 12 Content Pieces",
                "Upload Size Limit: 2MB per piece"
            ]
        },
        pro: {
            license_name: "Pro",
            maxUsers: 500,
            maxDecks: 5,
            features: [
                "500 Active Users",
                "All Product Features",
                "Max 60 Content Pieces",
                "Upload Size Limit: 10MB per piece",
                "Custom Domain",
                "Premium Themes",
                "Premium Games",
            ]
        },
        enterprise: {
            license_name: "Enterprise",
            maxUsers: 99999999,
            maxDecks: 9999999,
            features: [
                "500+ Active Users",
                "All Product Features",
                "Unlimited Content Pieces",
                "Upload Size Limit: 50MB per piece",
                "Custom Domain",
                "Language Selection",
                "Premium Themes",
                "Premium Games",
                "SMTP Integration",
                "GTM / Pixel Integrations",
                "Custom Journeys and Games",
                "Multiple Journeys"
            ]
        },
    },
}

module.exports = {
    licenseMap,
    licenseLadder
}